module.exports = __webpack_public_path__ + "img/base.1879cdf8.png";